'use client';

import { FC, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { ArrowRight, Sparkles, Ticket, Users, Calendar, X } from 'lucide-react';
import HotdeskButton from '@/hotdesk-ui/components/shared/HotdeskButton';
import styles from './Popup.module.scss';
interface PopupProps {
  show: boolean;
  handleClose: () => void;
}
export const Popup: FC<PopupProps> = ({
  show,
  handleClose
}) => {
  const t = useTranslations();
  useEffect(() => {
    if (!show) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [show, handleClose]);
  if (!show) return null;
  return <div className={styles.overlay} onClick={handleClose} data-sentry-component="Popup" data-sentry-source-file="Popup.tsx">
            <div className={styles.modal} onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
                <button type="button" className={styles.closeBtn} onClick={handleClose} aria-label="Close">
                    <X size={16} data-sentry-element="X" data-sentry-source-file="Popup.tsx" />
                </button>

                <span className={styles.iconBadge}>
                    <Sparkles size={24} data-sentry-element="Sparkles" data-sentry-source-file="Popup.tsx" />
                </span>

                <div className={styles.heading}>
                    <h2 className={styles.title}>
                        {t('calculator.popup.title')}
                    </h2>
                    <p className={styles.desc}>
                        {t('calculator.popup.desc')}
                    </p>
                </div>

                <div className={styles.preview}>
                    <span className={styles.previewLabel}>
                        {t('calculator.popup.results.title')}
                    </span>
                    <div className={styles.previewTotalRow}>
                        <span className={styles.previewAmount}>
                            {t('calculator.popup.results.title-span')}
                        </span>
                        <span className={styles.savePill}>
                            {t('calculator.popup.results.save')}
                        </span>
                    </div>

                    <div className={styles.metaRow}>
                        <span className={styles.metaPill}>
                            <Users size={14} data-sentry-element="Users" data-sentry-source-file="Popup.tsx" />
                            {t('calculator.Results.text.Employee')}
                            <strong>
                                90 {t('calculator.Results.text.Employee-unit')}
                            </strong>
                        </span>
                        <span className={styles.metaPill}>
                            <Calendar size={14} data-sentry-element="Calendar" data-sentry-source-file="Popup.tsx" />
                            {t('calculator.Results.text.day')}
                            <strong>
                                3 {t('calculator.Results.text.day-unit')}
                            </strong>
                        </span>
                    </div>

                    <div className={styles.solutionCard}>
                        <span className={styles.solutionIcon}>
                            <Ticket size={20} data-sentry-element="Ticket" data-sentry-source-file="Popup.tsx" />
                        </span>
                        <div className={styles.solutionContent}>
                            <p className={styles.solutionTitle}>
                                {t('calculator.popup.results.passes')}
                            </p>
                            <p className={styles.solutionDesc}>
                                {t('calculator.popup.results.passes-desc')}{' '}
                                <strong>
                                    {t('calculator.popup.results.passes-desc-span')}
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>

                <HotdeskButton variant="primary" size="md" className={styles.cta} iconRight={<ArrowRight size={18} />} onClick={handleClose} data-sentry-element="HotdeskButton" data-sentry-source-file="Popup.tsx">
                    {t('calculator.popup.button')}
                </HotdeskButton>
            </div>
        </div>;
};
export default Popup;